"use client";

import axios from "axios";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
export default function AxiosInterceptors() {
  const router = useRouter();
  const pathname = usePathname();
  const pathNameIsQuoteFormEdit = pathname?.includes("/quotes/");
  useEffect(() => {
    // add global axios interceptor
    axios.interceptors.response.use(response => response, error => {
      if (error.response && error.response.status === 403 && pathNameIsQuoteFormEdit) {
        console.error("Access forbidden: 403");
        router.push(`${pathname}/view`);
        return;
      }
      if (error.response && error.response.status === 403) {
        console.error("Access forbidden: 403");
        router.push("/");
      }
      if (error.response && error.response.status === 401) {
        console.error("Access forbidden: 403");
        router.push("/");
      }
      return Promise.reject(error);
    });
  });
  return null;
}